// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roles-page {
  min-height: 100vh;
}

@media (max-width: 1199px) {
  html.roles-page-lock {
    overflow: hidden;
  }

  .roles-page .content-wrapper {
    height: calc(100dvh - 64px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}

.roles-mobile-list {
  display: none;
}

.roles-mobile-empty {
  padding: 32px 20px;
  color: #71859a;
  text-align: center;
}

@media (max-width: 1199px) {
  body.roles-responsive-page #root {
    margin-left: 0 !important;
    overflow-x: hidden;
  }

  body.roles-responsive-page .sidenav---sidenav---_2tBP {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 12000;
    width: 0;
    min-width: 0;
    overflow: hidden;
    transform: translateX(-100%);
    transition: width .2s ease, transform .2s ease;
  }

  body.roles-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {
    width: min(280px, 86vw);
    min-width: min(280px, 86vw);
    overflow-y: auto;
    transform: translateX(0);
    box-shadow: 8px 0 24px rgba(15, 39, 60, .22);
  }

  body.roles-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL .sidenav---sidenav-toggle---1KRjR {
    display: block;
  }

  body.roles-responsive-page .barra-responsive-offcanvas {
    width: 100vw !important;
    max-width: 100vw !important;
    z-index: 13000;
  }

  body.roles-responsive-page .offcanvas-backdrop {
    z-index: 12990;
  }

  .roles-page #layout-navbar.custom-navbar-admin {
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;
    box-shadow: none !important;
  }

  .roles-page #layout-navbar {
    min-height: 64px;
    padding: 4px 12px 4px 8px;
  }

  .roles-page #layout-navbar .app-brand-link {
    min-width: 0;
    flex: 1 1 auto;
  }

  .roles-page #layout-navbar .app-brand-link img {
    width: min(190px, 100%);
    height: 56px !important;
    object-fit: contain;
    object-position: left center;
  }

  .roles-page #layout-navbar .navbar-nav-right {
    position: static;
    transform: none;
    flex: 0 0 auto;
  }

  .roles-page #layout-navbar .navbar-actions {
    gap: 4px;
  }

  .roles-page #layout-navbar .platform-navbar-menu-toggle,
  .roles-page #layout-navbar .platform-navbar-menu-toggle:hover,
  .roles-page #layout-navbar .platform-navbar-menu-toggle:focus,
  .roles-page #layout-navbar .platform-navbar-menu-toggle:focus-visible,
  .roles-page #layout-navbar .platform-navbar-menu-toggle:active,
  .roles-page #layout-navbar .platform-navbar-menu-toggle i {
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    outline: none !important;
  }

  .roles-page .content-wrapper { min-height: calc(100vh - 64px); }
}

@media (max-width: 767px) {
  .roles-page .content-wrapper {
    padding-bottom: calc(76px + env(safe-area-inset-bottom));
  }

  .roles-page {
    min-height: 100dvh;
    overflow-x: hidden;
    background: #f5f7fb;
  }

  .roles-page #layout-navbar {
    min-height: 60px;
    padding: 4px 8px;
  }

  .roles-page #layout-navbar .app-brand-link img {
    width: min(172px, 100%);
    height: 48px !important;
  }

  .roles-page .container-fluid.container-p-y {
    padding: 12px 12px 0;
  }

  .roles-toolbar {
    gap: 10px !important;
  }

  .roles-toolbar-actions,
  .roles-toolbar-search {
    width: 100%;
    padding-right: 0;
    padding-left: 0;
  }

  .roles-toolbar-actions .buttonsRole {
    gap: 8px;
  }

  .roles-toolbar-actions .nombreRol {
    width: 100%;
    margin: 4px 0 2px !important;
    color: #526a82;
    font-size: 21px;
    text-align: center;
  }

  .roles-toolbar-actions .buttonsRole button {
    min-height: 40px;
    border-radius: 7px;
    font-size: 12px;
    font-weight: 600;
  }

  .roles-search {
    height: 42px;
    margin-top: 4px;
    border: 1px solid #dce5ee;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
  }

  .roles-search .input-group-text {
    width: 42px;
    justify-content: center;
    border: 0;
    border-right: 1px solid #e2e9f0;
    background: #fff;
    color: #6f8498;
  }

  .roles-search .form-control {
    border: 0;
    box-shadow: none;
    color: #30475d;
  }

  .roles-search .form-control::placeholder {
    color: #a7b5c2;
  }

  .roles-desktop-list {
    display: none;
  }

  .roles-page .card {
    margin-top: 16px !important;
    border: 0;
    border-radius: 12px;
    background: transparent;
    box-shadow: none;
  }

  .roles-mobile-list {
    display: grid;
    gap: 10px;
  }

  .role-mobile-card {
    overflow: hidden;
    border: 1px solid #dce7f0;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 3px 12px rgba(31, 55, 80, .08);
  }

  .role-mobile-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    background: #006699;
    color: #fff;
  }

  .role-mobile-card-header i {
    font-size: 21px;
  }

  .role-mobile-card-id {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .08em;
    text-transform: uppercase;
  }

  .role-mobile-card-content {
    padding: 13px 14px 11px;
  }

  .role-mobile-card-label,
  .role-mobile-card-meta span {
    color: #7b8ea1;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .04em;
    text-transform: uppercase;
  }

  .role-mobile-card-content h3 {
    margin: 4px 0 14px;
    color: #334b63;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
  }

  .role-mobile-card-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding-top: 10px;
    border-top: 1px solid #edf2f6;
  }

  .role-mobile-card-meta span {
    display: inline-flex;
    align-items: center;
    gap: 5px;
  }

  .role-mobile-card-meta span i {
    color: #006699;
    font-size: 16px;
  }

  .role-mobile-card-meta strong {
    color: #526b84;
    font-size: 12px;
  }

  .role-mobile-card-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    padding: 0 14px 14px;
  }

  .role-mobile-card-actions button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    min-height: 36px;
    padding: 7px 8px;
    border: 1px solid #cfe0ec;
    border-radius: 7px;
    background: #f6faff;
    color: #006699;
    font-size: 11px;
    font-weight: 700;
  }

  .role-mobile-card-actions button:first-child {
    background: #006699;
    color: #fff;
  }

  .role-mobile-card-actions button:focus-visible {
    outline: 3px solid rgba(0, 102, 153, .25);
    outline-offset: 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/rolesResponsive.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,cAAc;IACd,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,8CAA8C;EAChD;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;IAChB,wBAAwB;IACxB,4CAA4C;EAC9C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,wCAAwC;IACxC,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;;;;;;IAME,kCAAkC;IAClC,wCAAwC;IACxC,iCAAiC;IACjC,oBAAoB;IACpB,2BAA2B;IAC3B,2BAA2B;IAC3B,wBAAwB;EAC1B;;EAEA,+BAA+B,8BAA8B,EAAE;AACjE;;AAEA;EACE;IACE,wDAAwD;EAC1D;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,SAAS;IACT,+BAA+B;IAC/B,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,yCAAyC;IACzC,mBAAmB;EACrB;AACF","sourcesContent":[".roles-page {\n  min-height: 100vh;\n}\n\n@media (max-width: 1199px) {\n  html.roles-page-lock {\n    overflow: hidden;\n  }\n\n  .roles-page .content-wrapper {\n    height: calc(100dvh - 64px);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n.roles-mobile-list {\n  display: none;\n}\n\n.roles-mobile-empty {\n  padding: 32px 20px;\n  color: #71859a;\n  text-align: center;\n}\n\n@media (max-width: 1199px) {\n  body.roles-responsive-page #root {\n    margin-left: 0 !important;\n    overflow-x: hidden;\n  }\n\n  body.roles-responsive-page .sidenav---sidenav---_2tBP {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 12000;\n    width: 0;\n    min-width: 0;\n    overflow: hidden;\n    transform: translateX(-100%);\n    transition: width .2s ease, transform .2s ease;\n  }\n\n  body.roles-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {\n    width: min(280px, 86vw);\n    min-width: min(280px, 86vw);\n    overflow-y: auto;\n    transform: translateX(0);\n    box-shadow: 8px 0 24px rgba(15, 39, 60, .22);\n  }\n\n  body.roles-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL .sidenav---sidenav-toggle---1KRjR {\n    display: block;\n  }\n\n  body.roles-responsive-page .barra-responsive-offcanvas {\n    width: 100vw !important;\n    max-width: 100vw !important;\n    z-index: 13000;\n  }\n\n  body.roles-responsive-page .offcanvas-backdrop {\n    z-index: 12990;\n  }\n\n  .roles-page #layout-navbar.custom-navbar-admin {\n    background: transparent !important;\n    background-color: transparent !important;\n    background-image: none !important;\n    box-shadow: none !important;\n  }\n\n  .roles-page #layout-navbar {\n    min-height: 64px;\n    padding: 4px 12px 4px 8px;\n  }\n\n  .roles-page #layout-navbar .app-brand-link {\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  .roles-page #layout-navbar .app-brand-link img {\n    width: min(190px, 100%);\n    height: 56px !important;\n    object-fit: contain;\n    object-position: left center;\n  }\n\n  .roles-page #layout-navbar .navbar-nav-right {\n    position: static;\n    transform: none;\n    flex: 0 0 auto;\n  }\n\n  .roles-page #layout-navbar .navbar-actions {\n    gap: 4px;\n  }\n\n  .roles-page #layout-navbar .platform-navbar-menu-toggle,\n  .roles-page #layout-navbar .platform-navbar-menu-toggle:hover,\n  .roles-page #layout-navbar .platform-navbar-menu-toggle:focus,\n  .roles-page #layout-navbar .platform-navbar-menu-toggle:focus-visible,\n  .roles-page #layout-navbar .platform-navbar-menu-toggle:active,\n  .roles-page #layout-navbar .platform-navbar-menu-toggle i {\n    background: transparent !important;\n    background-color: transparent !important;\n    background-image: none !important;\n    border: 0 !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    outline: none !important;\n  }\n\n  .roles-page .content-wrapper { min-height: calc(100vh - 64px); }\n}\n\n@media (max-width: 767px) {\n  .roles-page .content-wrapper {\n    padding-bottom: calc(76px + env(safe-area-inset-bottom));\n  }\n\n  .roles-page {\n    min-height: 100dvh;\n    overflow-x: hidden;\n    background: #f5f7fb;\n  }\n\n  .roles-page #layout-navbar {\n    min-height: 60px;\n    padding: 4px 8px;\n  }\n\n  .roles-page #layout-navbar .app-brand-link img {\n    width: min(172px, 100%);\n    height: 48px !important;\n  }\n\n  .roles-page .container-fluid.container-p-y {\n    padding: 12px 12px 0;\n  }\n\n  .roles-toolbar {\n    gap: 10px !important;\n  }\n\n  .roles-toolbar-actions,\n  .roles-toolbar-search {\n    width: 100%;\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .roles-toolbar-actions .buttonsRole {\n    gap: 8px;\n  }\n\n  .roles-toolbar-actions .nombreRol {\n    width: 100%;\n    margin: 4px 0 2px !important;\n    color: #526a82;\n    font-size: 21px;\n    text-align: center;\n  }\n\n  .roles-toolbar-actions .buttonsRole button {\n    min-height: 40px;\n    border-radius: 7px;\n    font-size: 12px;\n    font-weight: 600;\n  }\n\n  .roles-search {\n    height: 42px;\n    margin-top: 4px;\n    border: 1px solid #dce5ee;\n    border-radius: 8px;\n    overflow: hidden;\n    background: #fff;\n  }\n\n  .roles-search .input-group-text {\n    width: 42px;\n    justify-content: center;\n    border: 0;\n    border-right: 1px solid #e2e9f0;\n    background: #fff;\n    color: #6f8498;\n  }\n\n  .roles-search .form-control {\n    border: 0;\n    box-shadow: none;\n    color: #30475d;\n  }\n\n  .roles-search .form-control::placeholder {\n    color: #a7b5c2;\n  }\n\n  .roles-desktop-list {\n    display: none;\n  }\n\n  .roles-page .card {\n    margin-top: 16px !important;\n    border: 0;\n    border-radius: 12px;\n    background: transparent;\n    box-shadow: none;\n  }\n\n  .roles-mobile-list {\n    display: grid;\n    gap: 10px;\n  }\n\n  .role-mobile-card {\n    overflow: hidden;\n    border: 1px solid #dce7f0;\n    border-radius: 12px;\n    background: #fff;\n    box-shadow: 0 3px 12px rgba(31, 55, 80, .08);\n  }\n\n  .role-mobile-card-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 14px;\n    background: #006699;\n    color: #fff;\n  }\n\n  .role-mobile-card-header i {\n    font-size: 21px;\n  }\n\n  .role-mobile-card-id {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: .08em;\n    text-transform: uppercase;\n  }\n\n  .role-mobile-card-content {\n    padding: 13px 14px 11px;\n  }\n\n  .role-mobile-card-label,\n  .role-mobile-card-meta span {\n    color: #7b8ea1;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: .04em;\n    text-transform: uppercase;\n  }\n\n  .role-mobile-card-content h3 {\n    margin: 4px 0 14px;\n    color: #334b63;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 1.3;\n  }\n\n  .role-mobile-card-meta {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding-top: 10px;\n    border-top: 1px solid #edf2f6;\n  }\n\n  .role-mobile-card-meta span {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n  }\n\n  .role-mobile-card-meta span i {\n    color: #006699;\n    font-size: 16px;\n  }\n\n  .role-mobile-card-meta strong {\n    color: #526b84;\n    font-size: 12px;\n  }\n\n  .role-mobile-card-actions {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n    padding: 0 14px 14px;\n  }\n\n  .role-mobile-card-actions button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    min-height: 36px;\n    padding: 7px 8px;\n    border: 1px solid #cfe0ec;\n    border-radius: 7px;\n    background: #f6faff;\n    color: #006699;\n    font-size: 11px;\n    font-weight: 700;\n  }\n\n  .role-mobile-card-actions button:first-child {\n    background: #006699;\n    color: #fff;\n  }\n\n  .role-mobile-card-actions button:focus-visible {\n    outline: 3px solid rgba(0, 102, 153, .25);\n    outline-offset: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
